<cbs-product-content>
    <cbs-product-options [columnOptionLayout]="maxColumnOptionLayout | async"></cbs-product-options>
</cbs-product-content>
